module.exports = __webpack_public_path__ + "static/beneficio-3-e4efa9f8809a9ec1f2af770f508128d2.png";